import { render, staticRenderFns } from "./ListFolders.vue?vue&type=template&id=9ce2328c"
import script from "./ListFolders.vue?vue&type=script&lang=js"
export * from "./ListFolders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports